





































































































































































import { Component, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import { listAllIssueTransactions, listIssueTransactions } from '@/services/sorewards/console'
import { downloadCsv } from '@/services/sorewards/csv'
import { IssueRow, IssueStats } from '@/services/sorewards/types'
import SorewardsCaretakerSelect from '@/views/sorewards/components/caretaker-select.vue'
import SorewardsCostCell from '@/views/sorewards/components/cost-cell.vue'
import SorewardsCoverageBar from '@/views/sorewards/components/coverage-bar.vue'

@Component({
  name: 'SorewardsIssueTransactions',
  components: {
    Pagination,
    SorewardsCaretakerSelect,
    SorewardsCostCell,
    SorewardsCoverageBar
  }
})
export default class extends Vue {
  private listLoading = true
  private exporting = false
  private list: IssueRow[] = []
  private dateRange: [string, string] | null = null
  private listQuery = {
    page: 1,
    per: 20,
    caretakerId: '',
    caretakerName: '',
    cardId: '',
    dotationOrder: '',
    beneficiary: ''
  }

  private stats: IssueStats = {
    cardsIssued: 0,
    physicalCount: 0,
    virtualCount: 0,
    totalIssueCost: 0,
    filteredCount: 0,
    totalCount: 0
  }

  created() {
    this.getList()
  }

  private filters() {
    return {
      page: this.listQuery.page,
      per: this.listQuery.per,
      caretakerId: this.listQuery.caretakerId || undefined,
      caretakerName: this.listQuery.caretakerName || undefined,
      dateFrom: this.dateRange ? this.dateRange[0] : undefined,
      dateTo: this.dateRange ? this.dateRange[1] : undefined,
      cardId: this.listQuery.cardId || undefined,
      dotationOrder: this.listQuery.dotationOrder || undefined,
      beneficiary: this.listQuery.beneficiary || undefined
    }
  }

  private async getList() {
    this.listLoading = true
    try {
      const result = await listIssueTransactions(this.filters())
      this.list = result.data
      this.stats = result.stats
    } finally {
      this.listLoading = false
    }
  }

  private handleFilter() {
    this.listQuery.page = 1
    this.getList()
  }

  private resetFilters() {
    this.dateRange = null
    this.listQuery = {
      page: 1,
      per: this.listQuery.per,
      caretakerId: '',
      caretakerName: '',
      cardId: '',
      dotationOrder: '',
      beneficiary: ''
    }
    this.getList()
  }

  private cardTypeLabel(type: string) {
    return type === 'physical'
      ? String(this.$t('sorewardsConsole.physical'))
      : String(this.$t('sorewardsConsole.virtual'))
  }

  private async exportCsv() {
    this.exporting = true
    try {
      const filters = this.filters()
      const rows = await listAllIssueTransactions({
        caretakerId: filters.caretakerId,
        caretakerName: filters.caretakerName,
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        cardId: filters.cardId,
        dotationOrder: filters.dotationOrder,
        beneficiary: filters.beneficiary
      })
      downloadCsv(
        this.$i18n.locale === 'en' ? 'issue-transactions.csv' : 'emissions.csv',
        [
          String(this.$t('sorewardsConsole.cardId')),
          String(this.$t('sorewardsConsole.caretaker')),
          String(this.$t('sorewardsConsole.dotationOrder')),
          String(this.$t('sorewardsConsole.beneficiary')),
          String(this.$t('sorewardsConsole.issueDate')),
          String(this.$t('sorewardsConsole.cardNumber')),
          String(this.$t('sorewardsConsole.expiry')),
          String(this.$t('sorewardsConsole.cardType')),
          String(this.$t('sorewardsConsole.issuePrice')),
          String(this.$t('sorewardsConsole.coverIssue')),
          String(this.$t('sorewardsConsole.caretakerShare'))
        ],
        rows.map(row => [
          row.cardId,
          row.caretakerName,
          row.dotationOrder,
          row.beneficiary,
          row.issueDate,
          row.cardNumber,
          row.expiry,
          this.cardTypeLabel(row.cardType),
          row.cost.value,
          `${row.coverage}%`,
          row.cost.caretakerShare
        ])
      )
    } finally {
      this.exporting = false
    }
  }
}
